import { apiRequest, CompletedApiRequest } from './_tools';
import { Module } from 'common/dist/types/module';

export function fetchModules(): CompletedApiRequest<Module[]> {
  return apiRequest('/api/modules');
}
